import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '../Icon';
import { logEvent } from '../../../lib/shared/event-logger';
import { EVENT_TYPES } from '../../../lib/shared/event-types';
import { US_REGION } from '../../app-legal-regions';
import freshBakingSrc from '../../assets/images/slide/start-smell-fresh-baking.png';
import summerRainSrc from '../../assets/images/slide/start-smell-summer-rain.png';
import saltySeaSrc from '../../assets/images/slide/start-smell-salty-sea.png';
import oldBooksSrc from '../../assets/images/slide/start-smell-old-books.png';
import styles from './StartSlideV11.css';

const ANSWERS = [
    { id: 1, text: 'Fresh baking', image: freshBakingSrc },
    { id: 2, text: 'Summer rain', image: summerRainSrc },
    { id: 3, text: 'Salty sea', image: saltySeaSrc },
    { id: 4, text: 'Old books', image: oldBooksSrc }
];

function StartSlideV11({ id, onContinue, legalRegion }) {
    const handleChange = answer => () => {
        logEvent(EVENT_TYPES.QUIZ_START_CLICKED, { label: answer.text });
        onContinue();
    };

    return (
        <div className={styles.form} key={id}>
            <h1 className={styles.heading}>What does your childhood smell like?</h1>
            <p className={styles.subheading}>
                {legalRegion === US_REGION
                    ? 'Take this 2-minute quiz to personalize your subscription'
                    : 'A few questions to start your life story'
                }
            </p>
            <ul className={styles.answers}>
                {ANSWERS.map(answer => (
                    <li key={answer.id}>
                        <button
                            type='button'
                            onClick={handleChange(answer)}
                            className={styles.answerButton}
                        >
                            <img src={answer.image} alt='' className={styles.answerImage} />
                            <span className={styles.answerLabel}>
                                <span className={styles.answerText}>{answer.text}</span>
                                <Icon name='chevronRight' className={styles.answerIcon} />
                            </span>
                        </button>
                    </li>
                ))}
            </ul>
        </div>
    );
}

StartSlideV11.propTypes = {
    id: PropTypes.number.isRequired,
    onContinue: PropTypes.func.isRequired,
    legalRegion: PropTypes.string
};

export {
    StartSlideV11
};
